<template>
  <div class="d-flex flex-grow-1 position-relative bg-primary">
    <div class="front">
      <div class="bg-bar">
        <md-toolbar class="md-transparent top-bar" md-elevation="0">
          <router-link to="/">
            <img class="logo" src="../assets/logo/w-virtex@1.5x.png" alt="">
          </router-link>
          <div class="d-flex flex-grow-1 justify-content-end">
            <md-button @click="handleBack" md-theme="black">Voltar</md-button>
          </div>
        </md-toolbar>
      </div>
      <div class="d-flex container-form flex-grow-1 justify-content-center align-items-center">
        <div class="col-md-6 col-sm-10 col-12">
          <md-card md-theme="black" class="md-elevation-7 form-card">
            <md-card-header>
              <div class="md-title">Selecione a sua Cidade</div>
            </md-card-header>

            <md-card-content>
              <div class="row">
                <div class="col-1 d-none d-lg-flex align-items-center justify-content-start">
                  <md-icon class="md-size-2x w-100 d-none d-lg-flex">location_city</md-icon>
                </div>
                <div class="col-12 col-lg-11 pt-2 pb-2">
                  <div class="bg-bar rounded pt-1 pb-3 pl-3 pr-3">
                    <md-field class="mb-0">
                      <label for="cities">Cidades</label>
                      <md-select @md-selected="changeCity" class="mb-0" v-model="citySelected" name="cities" id="cities">
                        <md-option
                          v-for="val in cityList"
                          :key="val.cityCode"
                          :value="val.cityCode">{{ val.cityName }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <small class=" mb-2 d-lg-none d-inline-block">Selecione uma cidade acima para continuar.</small>
                </div>
                <div class="col-12 align-items-center justify-content-end d-flex">
                  <small class="mr-3 d-none d-lg-inline-block">Selecione uma cidade acima para continuar.</small>
                  <div v-if="errorLoad">
                    <md-button @click="handleTryRenew() | hiddenSnack()" class="md-raised md-primary m-0">
                      Carregar Novamente
                    </md-button>
                  </div>
                  <div v-else>
                    <md-button @click="handleNextCity" class="md-raised md-accent m-0 mr-3">
                      Cidade mais Proxíma
                    </md-button>
                    <md-button @click="redirect" :disabled="!citySelected || load" class="md-raised md-primary m-0 mt-0" style="width: 20%">
                      Entrar
                    </md-button>
                  </div>
                </div>
              </div>
            </md-card-content>
            <md-progress-bar v-if="load" md-mode="indeterminate"></md-progress-bar>
          </md-card>
        </div>
        <md-snackbar md-position="left" :md-duration="3000" :md-active.sync="showSnackbarErr">
          <span>Não foi possível buscar a lista de cidades</span>
          <md-button class="md-primary" @click="handleTryRenew() | hiddenSnack()">Retry</md-button>
        </md-snackbar>
        <md-snackbar md-position="left" :md-duration="2300" @md-closed="redirect" :md-active.sync="showSnackbarAutoSelect">
          <span>Sua cidade mais proxíma é {{ sharedState.cityInfo.nomeCidade }}, você está sendo redirecionado...</span>
        </md-snackbar>
      </div>
    </div>
    <div class="back">
      <iframe src="/animated-background/waves.html" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
  import getCityList from '../scripts/getCityList'
  import getUserCityDataByCode from '../scripts/getCityDataByCode'
  import getNextCityCode from '../scripts/getNextCityCode'
  import nameCityToCode from '../scripts/nameCityToCode'
  import { HOME } from "../consts/routes";
  import { setCityCode } from "../scripts/storageCityCode";

  export default {
    name: "CitySelect",
    data() {
      return {
        citySelected: "",
        cityList: [{ cityCode: "", cityName: "" }],
        errorLoad: false,
        showSnackbarErr: false,
        showSnackbarAutoSelect: false,
        load: false,
        sharedState: this.$store.state
      }
    },
    created() {

      let cityList = getCityList();

      this.load = true;

      cityList.then(list => {
        this.load = false;
        this.errorLoad = false;
        this.showSnackbarErr = false;
        this.cityList = [...list]
      });

      cityList.catch(() => {
        this.load = false;
        this.showSnackbarErr = true;
        this.errorLoad = true;
      })

    },
    methods: {
      handleBack() {
        this.$router.go(-1)
      },
      handleTryRenew() {
        let cityList = getCityList();

        this.load = true;

        cityList.then(list => {
          this.load = false;
          this.errorLoad = false;
          this.showSnackbarErr = false;
          this.cityList = [...list]
        });

        cityList.catch(() => {
          this.load = false;
          this.showSnackbarErr = true;
          this.errorLoad = true;
        })

      },
      hiddenSnack() {
        this.showSnackbarErr = false;
      },
      handleNextCity() {
        const gncc = getNextCityCode();

        gncc.then(code => {
          this.showSnackbarErr = false;
          this.citySelected = code;
          this.showSnackbarAutoSelect = true;
        });

        gncc.catch(() => {
          this.showSnackbarErr = true;
        })
      },
      changeCity() {
        let { citySelected } = this;
        if(!citySelected) { return; }

        this.load = true;

        const gucdbc = getUserCityDataByCode(citySelected);

        gucdbc.then(data => {
          this.load = false;
          this.errorLoad = false;
          this.$store.commit('setCityInfo', { cityCode: nameCityToCode(data.nomeCidade), cityInfo: data });
        });

        gucdbc.catch(() => {
          this.load = false;
          this.errorLoad = true;
        })

      },
      redirect() {
        let { citySelected } = this;
        if(!citySelected) { return; }

        const scc = setCityCode(citySelected);
        this.load = true;

        scc.then(() => {
          this.load = false;
          this.$store.dispatch('redirectTo', HOME)
        });

        scc.catch(() => {
          this.load = false;
          this.errorLoad = true
        })

      }
    }
  }
</script>

<style scoped lang="scss">

  .back {
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 100%;
    flex: 1 1 auto;
    position: absolute;
    z-index: 1;
    iframe {
      display: flex;
      flex: 1 1 auto;
      object-fit: cover;
    }
  }

  .bg-bar {
    background-color: rgba(0, 0, 0, 0.26);
  }

  .logo {
    width: 180px;
  }

  .front, .container-form {
    pointer-events: none;
  }

  .form-card, .top-bar {
    pointer-events: all;
  }

  .front {
    background: radial-gradient(ellipse at center, rgba(0,0,0,0) 0%,rgba(0,0,0,0.45) 82%, rgba(0,0,0,0.65) 100%);
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    position: absolute;
    z-index: 2;

  }
</style>
